import 'rxjs/add/operator/debounceTime';
import {Component, ElementRef, ViewChild} from '@angular/core';
import {Content, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TAction} from '../../../app/enum';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {SpotdayService} from "../../../providers/spotday-service";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {ProfileService} from "../../../providers/profile-service";


@Component({
    selector: 'page-spotday-view',
    templateUrl: 'spotday-view.html',
    providers: [ProfileService, ProfileRepository, SpotdayService]
})
export class SpotdayViewPage {

    config: any;
    logado: any;
    perfil: any;

    spotday: any;
    etapa: number;
    tipoview: number;

    infoShow: boolean = false;

    og: object = {};
    linkdayText: string;

    page1: any;
    page2: any;
    notifyes: any;

    @ViewChild(Content) content: Content;
    @ViewChild('barraRoxa') barraRoxa: ElementRef;
    @ViewChild('infoBlock') infoBlock: ElementRef;
    @ViewChild('infoBlockBtn') infoBlockBtn: ElementRef;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams,
                public util: Util, public logadoService: LogadoService, public profileService: ProfileService,
                public profileRepository: ProfileRepository, public spotdayService: SpotdayService) {

        this.page1 = SpotdayViewPage;
        this.page2 = SpotdayViewPage;

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.tipoview = 0;

        this.spotday = this.navParams.get('spotday');


        if (this.etapa == 1) this.centralLoad();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Spotday View', '/spotday-view');

    }

    ionViewDidLoad() {

        if (this.etapa == 0) this.infoBlock.nativeElement.style.transition = 'height 0.3s';

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    getTitle() {

        return this.spotday.Projeto.ProjetoNome + ' ' + this.util.dataft(this.spotday.SpotdayDate, 'dd', 'num', null, '/');

    }

    load(spotdayID) {


    }

    centralLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService
            .central(TAction.acLoad, '', this.logado.Profile.ProfileID, 0, 0)
            .finally(() => loading.dismiss())
            .subscribe(
                (data) => this.notifyes = data.Notifyes,
                (erro) => this.util.alertResult(erro, () => this.dismiss())
            );
        
    }




    /** ************************************************* EVENTO ************************************************** **/
    /** ************************************************* etapa-0 ************************************************* **/

    toggleInfo() {

        this.infoShow = !this.infoShow;

        if (this.infoShow) {

            this.infoBlock.nativeElement.scrollTop = 0;

            this.content.scrollTo(0, 0, this.content.getScrollElement().scrollTop ? 300 : 0, () => {

                setTimeout(() => {
                    this.infoBlock.nativeElement.style.overflowY = 'auto';
                }, 300);

                this.content.getScrollElement().style.overflowY = 'hidden';

                this.barraRoxa.nativeElement.style.boxShadow = 'rgba(0,0,0,0.4) 0px 3px 3px';
                //this.infoBlock.nativeElement.style.height = (this.content.contentHeight - this.barraRoxa.nativeElement.offsetHeight - this.infoBlockBtn.nativeElement.offsetHeight) + 'px';
                
                //#MODIFY - add duas linhas para descer o valor do topo, e comentado a linha acima
                this.infoBlock.nativeElement.style.height = (this.content.contentHeight - this.infoBlockBtn.nativeElement.offsetHeight) + 'px';
                this.barraRoxa.nativeElement.style.display = 'none';
            });

        }
        else {

            this.content.getScrollElement().style.overflowY = 'auto';

            this.barraRoxa.nativeElement.style.boxShadow = '0 0 0 rgba(0,0,0,0)';
            this.barraRoxa.nativeElement.style.display = ''; //#MODIFY - add linha para descer o valor do topo

            this.infoBlock.nativeElement.style.height = '0';
            this.infoBlock.nativeElement.style.overflowY = 'hidden';

        }

    }

    spotdayLink() {

        //let params = '&spotdayid=' + this.spotday.SpotdayID + '&profileid=' + this.logado.Profile.ProfileID;
        //this.profileRepository.sharedyLink(TShareupTipo.shSpotday, this.meritums[0].MeritumNome, 'spotday', params);

    }

    linkdayTest() {

        if (!this.linkdayText.trim().length || this.linkdayText.substr(0, 4) !== 'http') {
            this.util.alertSimply('Verifique se copiou e colou corretamente.', 'Link inválido!');
            return;
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.logadoService.started(TAction.acLink, null, '&Format=JSON')
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    let el = document.createElement('html');
                    el.innerHTML = data.Html;
                    let metas = el.getElementsByTagName('meta');

                    let ogData = {};

                    for (let a in metas) {
                        if (a !== 'item' && typeof metas[a] == 'object' && typeof metas[a].getAttribute !== 'undefined') {
                            if (metas[a].getAttribute("property") && metas[a].getAttribute("property").substr(0, 3) == 'og:') {
                                ogData[metas[a].getAttribute("property").substr(3)] = metas[a].getAttribute("content");
                            }
                        }
                    }

                    this.og = ogData;

                },
                erro => {

                    this.util.alertResult(erro);

                });

    }


    conlis(tipo) {

        this.tipoview = tipo;

    }



    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/spotday-view/spotday-view.ts